import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';


export interface GetExecutionExplanationVars {
    dataPlaneType: String;
    placementConstraintId: String;
    startTime: String;
    endTime: String;
    limit: number;
}

const GET_EXECUTION_EXPLANATION = gql`
    query GetExecutionExplanation(
            $dataPlaneType: String!
            $placementConstraintId: String!
            $startTime: String!
            $endTime: String!
            $limit: Int!
        ){
        getExecutionExplanation(
            dataPlaneType: $dataPlaneType
            placementConstraintId: $placementConstraintId
            startTime: $startTime
            endTime: $endTime
            limit: $limit
        )
    }
`;

export const useExecutionExplanationQuery = () => {
    return useLazyQuery<AnyObject, GetExecutionExplanationVars>(GET_EXECUTION_EXPLANATION, {
        errorPolicy: 'all',
    });
};